export default __webpack_public_path__ + "static/media/demand.bb35d507.svg";